export const COMMENTS_LOADED = "comments/loaded"
export const COMMENTS_ADDED = "comments/added"
export const COMMENT_ADDED = "comments/commentAdded"
export const COMMENTS_DELETED = "comments/commentsDeleted"